import { Moment } from 'moment';

export class CaixaEconomicaVO {

  dataSituacao: Moment;
  dataValidade: Moment;
  inscricao: string;
  certificacao: string;

}
